import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { Component } from 'react';
import { Card, defaultImageCardDimensions, CardLoading } from '@atlaskit/media-card';
import { FilmstripView } from './filmstripView';
import { generateIdentifierKey } from './utils/generateIdentifierKey';
export class Filmstrip extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      animate: false,
      offset: 0
    });

    _defineProperty(this, "handleSize", ({
      offset
    }) => this.setState({
      offset
    }));

    _defineProperty(this, "handleScroll", ({
      animate,
      offset
    }) => this.setState({
      animate,
      offset
    }));
  }

  renderCards() {
    const {
      items,
      mediaClientConfig,
      shouldOpenMediaViewer,
      featureFlags
    } = this.props;
    const mediaViewerDataSource = shouldOpenMediaViewer ? {
      list: items.map(item => item.identifier)
    } : undefined;
    return items.map(item => {
      const key = generateIdentifierKey(item.identifier);

      if (!mediaClientConfig) {
        return /*#__PURE__*/React.createElement(CardLoading, {
          key: key,
          dimensions: defaultImageCardDimensions
        });
      }

      return /*#__PURE__*/React.createElement(Card, _extends({
        key: key,
        mediaClientConfig: mediaClientConfig,
        dimensions: defaultImageCardDimensions,
        useInlinePlayer: false,
        shouldOpenMediaViewer: shouldOpenMediaViewer,
        mediaViewerDataSource: mediaViewerDataSource,
        featureFlags: featureFlags
      }, item));
    });
  }

  render() {
    const {
      testId = 'media-filmstrip'
    } = this.props;
    const {
      animate,
      offset
    } = this.state;
    return /*#__PURE__*/React.createElement(FilmstripView, {
      animate: animate,
      offset: offset,
      onSize: this.handleSize,
      onScroll: this.handleScroll,
      testId: testId
    }, this.renderCards());
  }

}